import { render, staticRenderFns } from "./KelengkapanNonAktif.vue?vue&type=template&id=1b5b7146&"
import script from "./KelengkapanNonAktif.vue?vue&type=script&lang=js&"
export * from "./KelengkapanNonAktif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports